<template>
<div v-if="!loading">
  <div class="wui-container lifestyle-detail" v-if="info?.status !== 0">
    <Swiper
        type="lifestyle"
        :video="info.videoUrl"
        :cover="util.thumb(info.coverUrl,500)"
        :imgs="info.imageUrls"
        :height="555"
    ></Swiper>
    <User :user="info.user"></User>

    <div class="detail">
      <div class="desc" v-html="info.content"></div>
      <div class="tag-preview">
        <div class="location" v-if="info.createdAt">
          <span class="submit-time">
            {{ formatDate(info.createdAt) }}
          </span>
          <template v-if="info.city">
            <span class="location">{{ info.city }}</span>
            <span v-if="info.location || info.district"> · </span>
          </template>
          <span class="location">{{ info.location || info.district }}</span>
        </div>
        <div class="preview">
          <span class="iconfont icon-View"></span>
          <span class="preview">{{ info.viewCount }}</span>
        </div>
      </div>
    </div>

    <CommentList :id="id" type="1" :userId="info.userId"></CommentList>

    <div class="footer-fixed">
      <div
          class="input"
          @click="$downloadApp('subjectDetail', { subjectId: id })"
      >
        <div class="box">
          {{ $t("发表你的天才演讲") }}
        </div>
      </div>
      <div
          class="btn-collect"
          @click="$downloadApp('subjectDetail', { subjectId: id })"
      >
        <span class="iconfont icon-1xin"></span>
        <span class="number">{{ info.collectCount }}</span>
      </div>
      <div class="btn-comment">
        <span class="iconfont icon-messageNumber"></span>
        <span class="number">{{ info.commentCount }}</span>
      </div>
    </div>
    <HomeButton bottom="80px"></HomeButton>
  </div>
  <Empty v-else/>
</div>
</template>

<script>
import {useRoute} from "vue-router";

import api from "@/api/index";
import User from "@/components/User.vue";
import Swiper from "@/components/Swiper.vue";
import CommentList from "@/components/CommentList.vue";
import HomeButton from "@/components/HomeButton.vue";
import {initWechatJSSDK} from "@/assets/wechat.js";
import Empty from "@/components/Empty.vue";

export default {
  components: {
    Empty,
    User,
    Swiper,
    CommentList,
    HomeButton,
  },
  data() {
    return {
      id: "",
      info: {},
      loading: false,
    };
  },
  mounted() {
    this.getLifestyleInfo();
    window.scrollTo(0, 0);
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp * 1000);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${month}-${day}`;
    },
    tagMatch(s) {
      var reg = /#.*? |#.*/g;
      s = s.match(reg);
      return s;
    },
    getLifestyleInfo() {
      const route = useRoute();
      this.id = route.params.id;
      this.loading = true;
      api.community
          .getInfo(this.id)
          .then((res) => {
            let tagArr = this.tagMatch(res.data.content) || [];
            tagArr.forEach((item, index) => {
              res.data.content = res.data.content.replace(
                  item,
                  `<a class='tag' href='/community/tag?tag=${encodeURIComponent(
                      item.replace("#", "").trim()
                  )}'>${item}</a>`
              );
            });
            this.info = res.data;
            if(res.data.status === 0){
              document.title = "内容已关闭"
            }else{
              document.title = `${this.info.title}-${this.info.location}`;
            }
            initWechatJSSDK({
              title: this.info.title,
              desc: this.info.content,
              imgUrl: this.info.coverUrl,
            });
          }).finally(()=>{
            this.loading = false;
          })
    },
  },
  setup() {
  },
};
</script>

<style>
.lifestyle-detail {
  padding-bottom: 79px;
}

.detail {
  background-color: #ffffff;
  margin-bottom: 10px;
  padding: 15px;
  border-radius: 15px;
}

.detail .location, .detail .submit-time {
  display: flex;
  align-items: center;
  height: 20px;
  font-size: 12px;
  color: #999;
  line-height: 1;
}

.detail .submit-time {
  margin-right: 4px;
}

.detail .location .iconfont {
  margin-right: 4px;
  font-size: 14px;
  color: #111111;
}

.detail .preview {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666666;
}

.detail .preview .iconfont {
  margin-right: 4px;
  font-size: 13px;
}

.detail .desc {
  font-size: 14px;
  color: #000000;
  line-height: 24px;
  white-space: pre-wrap;
  text-align: left;
}

.detail .desc a {
  display: inline;
  color: #2db6b5;
  /* text-decoration: underline; */
}

.detail .tag-preview {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.detail .tag {
  flex: 1;
  display: flex;
  margin-top: 10px;
}

.detail .tag .tag-item {
  display: inline-flex;
  padding: 0 7px;
  border: 1px solid rgba(17, 17, 17, 0.03);
  border-radius: 6px;
  height: 23px;
  align-items: center;
  font-size: 12px;
  color: #666666;
  margin-right: 10px;
  margin-bottom: 10px;
}

.footer-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 0;
  background-color: #ffffff;
  z-index: 1000;
  border-top: 1px solid #f8f8f8;
  display: flex;
  max-width: 500px;
  margin: 0 auto;
}

.footer-fixed .input {
  padding: 0 15px;
  flex: 1;
}

.footer-fixed .input .box {
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border-radius: 6px;
  height: 44px;
  padding-left: 12px;
  font-size: 14px;
  color: #666666;
}

.footer-fixed .btn-collect,
.footer-fixed .btn-comment {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 44px;
}

.footer-fixed .btn-collect .number,
.footer-fixed .btn-comment .number {
  font-size: 12px;
  line-height: 17px;
  color: #111111;
}

.footer-fixed .btn-collect .iconfont {
  font-size: 20px;
  line-height: 18px;
  margin-bottom: 2px;
  color: #111111;
}

.footer-fixed .btn-collect .icon-CollectFill {
  color: #2db6b4;
}

.footer-fixed .btn-comment .iconfont {
  font-size: 18px;
  line-height: 18px;
  margin-bottom: 2px;
  color: #111111;
}
</style>
